<template>
  <div style="width: 700px;">
    <el-row>
      <el-col :span="24">
        <el-card class="box-card" style="width: 750px; margin: 0px auto;">
          <div slot="header" class="clearfix">
            <span>报价器-天涯明月刀</span>
          </div>
          <el-tabs v-model="activeType" type="card">
            <el-tab-pane label="段位代练" name="Dan">
              <div>
                <el-row>
                  <el-col :span="12">
                    <div style="display: flex;flex-wrap: wrap;">
                      <dan v-for="(item,index) in dans"
                           :key="index"
                           :data="item"
                           :selectedDans="selectedDans"
                           @selected="handleSelected"/>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <el-form ref="form" label-width="50px" label-position="left">
                      <el-form-item label="区服">
                        <el-radio-group v-model="zone" size="mini">
                          <el-radio-button border label="ANDRIOD">安卓</el-radio-button>
                          <el-radio-button border label="IOS">IOS</el-radio-button>
                        </el-radio-group>
                        <el-radio-group v-model="server" size="mini" style="margin-left: 10px;">
                          <el-radio-button border label="QQ">QQ</el-radio-button>
                          <el-radio-button border label="WECHAT">微信</el-radio-button>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item label="起始">
                        <span >
                            {{starCount.startStar.label}}
                          </span>
                      </el-form-item>

                      <el-form-item label="结束" >
                          <span>
                            {{starCount.endStar.label}}
                          </span>
                      </el-form-item>

                      <el-form-item>
                        <span class="desc_text">报价文本包含预计时间</span>
                        <el-switch
                          v-model="showEstimateTime"
                        >
                        </el-switch>
                      </el-form-item>
                    </el-form>
                  </el-col>
                </el-row>
              </div>
            </el-tab-pane>
          </el-tabs>
          <div>
            <el-row>
              <el-col :span="24">
                <div style="float: right">
                  <el-button type="primary" @click="genPrice" style="margin-left: 5px" class="btnGen" id="btnGen">生成报价
                  </el-button>
                  <el-button type="primary"  @click="gokTotalPrice" style="margin-left: 5px" class="btnDis" id="btnDis" ref="btnDis" >整单优惠</el-button>
                  <el-button id="btnCopy" v-clipboard:copy="content" v-clipboard:success="onCopy"
                             v-clipboard:error="onError" ref="btnCopy">复制报价
                  </el-button>
                  <el-button @click="reset" id="btnReset">重置查询</el-button>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-top: 10px">
              <el-col :span="24">
                <el-input type="textarea" :row="5" placeholder="报价内容" v-model="content"
                          :autosize="{ minRows: 3, maxRows: 10}"></el-input>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div></div>
    <keywords :do-copy="doCopy" :gen-price="genPrice" :reset="reset" :gok-total-price="gokTotalPrice"></keywords>
  </div>
</template>

<script>
  import Dan from '../components/TYDan'
  import keywords from '../components/keywords/keywords'
  export default {
    name: 'home',
    components: { Dan,keywords },
    data () {
      return {
        pricingType:'GOK_LEVELING',
        gameId: 61,
        dans: this.$store.state.tyDans,
        selectedDans: [],
        groupType: 'FOUR',
        startStarCount: 1,
        endStarCount: 1,
        showEstimateTime: true,
        content: '',
        activeType: 'Dan',
        prompt: true,
        fromPoint: 4200,
        toPoint: 4200,
        zone: 'ANDRIOD',
        server: 'QQ',
        inscriptionId:1,
        inscriptions:'',
        starCount:{
          startStar: {
            label:'起始',
            count:1
          },
          endStar: {
            label:'结束',
            count:1
          },
          keyNum:1
        },
        //整单优惠
        discountType:'NORMAL',
      }
    },
    mounted () {
      //this.enterKeyup()
    },
    computed: {
      sortedSelectedDans () {
        let target = []
        Object.assign(target, this.selectedDans)
        target.sort((x, y) => {
          let xDanIndex = this.dans.findIndex((i) => {
            return i.name === x.dan
          })
          let yDanIndex = this.dans.findIndex((i) => {
            return i.name === y.dan
          })

          return xDanIndex - yDanIndex
        })
        return target
      }
    },
    methods: {

      handleSelected (value) {
        let index = this.selectedDans.findIndex((x) => {
          return x.dan === value.dan
        })
        if (index === -1) {
          if (this.selectedDans.length === 2) {
            this.selectedDans.splice(0, 1)
          }
          this.selectedDans.push(value)
        } else {
          this.selectedDans.splice(index, 1)
        }
        this.setDan()
      },
      setDan(){
        if (this.selectedDans.length==1){
          this.selectedDans.push(this.selectedDans[0])
        }
        this.compareDansLevel()
        this.setLabel()
      },
      setLabel(){
        this.starCount.startStar.label=this.selectedDans[0].label
        this.starCount.endStar.label=this.selectedDans[1].label
      },
      //等级判断
      compareDansLevel(){
        if (this.selectedDans.length<2){
          return
        }
        if(this.selectedDans[0].level>this.selectedDans[1].level){
          //解构赋值
          this.selectedDans = [this.selectedDans[1], this.selectedDans[0]]
        }
      },
      formatSubDan (subDan) {
        if (subDan === 'A' || subDan === 'B') {
          subDan = ''
        }
        return subDan
      },
      genPrice (event) {
        let that = this
        this.discountType='NORMAL'
        that.gokDanPrice()
      },
      // 代练报价
      gokDanPrice () {
        let that = this
        if(that.sortedSelectedDans.length==0){
          this.$message('请选择段位！')
          return false
        }
        let startDan = that.sortedSelectedDans[0].label
        let thatEndDan = 0
        if (that.sortedSelectedDans.length == 1) {
          thatEndDan = that.sortedSelectedDans[0].label
        } else {
          thatEndDan = that.sortedSelectedDans[1].label
        }

        let data = {
          discountType:this.discountType,
          gameId: that.gameId,
          zone: that.zone,
          server: that.server,
          fromDan: startDan,
          toDan: thatEndDan,
          showTime: that.showEstimateTime
        }
        this.$http.post('/api/tianya/price/dan', data).then((res) => {
          if (res == null) {
            return
          }
          this.content = res.data
          this.doCopy(this.content)
          this.$message('代练报价生成成功！')
        })
      },

      reset () {
        let that = this
        this.selectedDans = []
        this.startStarCount = 1
        this.endStarCount = 1
        this.groupType = 'FOUR'
        this.starCount={
          startStar: {
            label:'起始',
              count:1
          },
          endStar: {
            label:'结束',
              count:1
          },
          keyNum:1
        }
       this.zone='ANDRIOD'
        this.server= 'QQ'
        this.discountType='NORMAL'
        this.content=''
        this.$message('重置成功')
      },
      onCopy (e) {
        this.$message('内容已复制到剪切板！')
      },
      // 复制失败时的回调函数
      onError (e) {
        this.$message('抱歉，您的浏览器不支持！')
      },
      doCopy (e) {
        let that = this
        that.$copyText(this.content).then(function (e) {
          that.$message('内容已复制到剪切板')

        }, function (e) {
          if (that.prompt) {
            that.prompt = false
            that.$message('您的浏览器不支持自动复制,请点击右侧复制按钮,或下载Chrome浏览器使用！')
          }

        })
      },
      enterKeyupDestroyed () {
        document.removeEventListener('keyup', this.enterKey)
      },
      enterKeyup () {
        document.addEventListener('keyup', this.enterKey)
      },
      enterKey (event) {
        const componentName = this.$options.name

        if (componentName == 'home') {
          const code = event.keyCode
            ? event.keyCode
            : event.which
              ? event.which
              : event.charCode

          if (code == 32) {
            this.genPrice()
          } else if (code == 13) {
            this.doCopy()
          }else if(code ==192){
            this.reset()
          }
        }
      },
      showMessage (msg, duration) {
        let that = this
        that.$message({
          showClose: true,
          message: msg,
          type: 'warning',
          duration: duration
        })
      },
      //整单优惠报价
      gokTotalPrice(){
        let that=this
        this.discountType='TOTAL'
        that.gokDanPrice()
      },
    },
    destroyed () {
      let that = this
      that.$message.closeAll()
      this.enterKeyupDestroyed()
    },
    beforeDestroy(){
      // 销毁enter事件
      this.enterKeyupDestroyed()
    },
  }
</script>

<style lang="stylus" scoped>
  .desc_text {
    height 40px;
    line-height 40px;

  }
</style>
